export default __webpack_public_path__ + "static/media/nt-brand-circle.7ea93876.png";